import { JSX } from 'react';
import { NoSelfReferContent } from '../../../components/therapy/NoSelfReferContent';

export const NoSelfReferBlocked = (): JSX.Element => {
  return <NoSelfReferContent showReturnButton={false} testIdPrefix="no-self-refer-blocked" />;
};
